import { AUTH_SIGN_IN_URL } from 'src/common/external/aws/constants';

export function redirectUnauthedUser() {
  if (!AUTH_SIGN_IN_URL) {
    throw new Error('AUTH_SIGN_IN_URL is not defined');
  }

  window.location.replace(AUTH_SIGN_IN_URL);
}
